import { abilitiesPlugin } from '@casl/vue';
import Vue from 'vue';
import { ability } from '../auth/abilities';

Vue.use(abilitiesPlugin, ability);
